import { cn } from "@/common/helpers/utils";
import { LoaderSvg, type VehicleLoaderProps } from "../loader-svg-parts";

const RIM_SPOKE_ANGLES = [0, 72, 144, 216, 288];

export function VehicleLoaderWheel({ className, inheritColor = false }: VehicleLoaderProps) {
  return (
    <LoaderSvg viewBox="0 0 24 24" className={className}>
      <circle
        cx={12}
        cy={12}
        r={9}
        strokeWidth={3}
        className={cn("fill-none", inheritColor ? "stroke-current/20" : "stroke-primary/20")}
      />
      <g className="vehicle-loader-spinner-arc">
        <circle
          cx={12}
          cy={12}
          r={9}
          pathLength={100}
          strokeDasharray="28 72"
          strokeWidth={3}
          strokeLinecap="round"
          className={cn("fill-none", inheritColor ? "stroke-current" : "stroke-primary")}
        />
      </g>
      <g
        className={cn("vehicle-loader-spinner-rim", inheritColor ? "stroke-current/70" : "stroke-primary/70")}
        strokeLinecap="round"
      >
        {RIM_SPOKE_ANGLES.map((angle) => {
          const radians = (angle * Math.PI) / 180;
          return (
            <line
              key={angle}
              x1={12 + Math.cos(radians) * 2.6}
              y1={12 + Math.sin(radians) * 2.6}
              x2={12 + Math.cos(radians) * 5.6}
              y2={12 + Math.sin(radians) * 5.6}
              strokeWidth={1.6}
            />
          );
        })}
        <circle cx={12} cy={12} r={1.6} className={cn("stroke-none", inheritColor ? "fill-current" : "fill-primary")} />
      </g>
    </LoaderSvg>
  );
}
